export const windowSelectorStyles = (theme) => {
  return {
    border: `2px solid ${theme.palette.primary.main}`,
    minHeight: "unset",
    height: "30px",
    padding: "2px",
    "& .MuiTab-root": {
      flex: 1,
      padding: 0,
      margin: 0,
      minHeight: "24px",
      minWidth: "unset",
      color: theme.palette.primary.main,
      fontWeight: 400,
    },
    "& .Mui-selected": {
      border: "unset",
      backgroundColor: theme.palette.primary.main,
      color: "white !important",
    },
  };
};

export const typeSelectorStyles = (theme) => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "& .item": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end",
      alignItems: "center",
      minHeight: "68px",
      height: "68px",
      width: "24%",
      minWidth: "unset",
      color: "#004057",
      border: `2px solid #F0F3F4`,
      paddingBottom: "4px",
      cursor: "pointer",
    },
    "& .active": {
      backgroundColor: "#F0F3F4",
    },
    "& .ev-icon": {
      height: "30px",
    },
    "& .solar-selected": {
      backgroundColor: "rgba(245, 147, 0, 0.03)",
      border: `2px solid #F59300`,
    },
    "& .grid-selected": {
      backgroundColor: "rgba(0, 64, 87, 0.03)",
      border: `2px solid #004057`,
    },
    "& .battery-selected": {
      backgroundColor: "rgba(249, 180, 38, 0.03)",
      border: `2px solid #F9B426`,
    },
    "& .house-selected": {
      backgroundColor: "rgba(40, 177, 120, 0.03)",
      border: `2px solid #28B178`,
    },
    "& .ev-selected": {
      backgroundColor: "rgba(78, 193, 234, 0.03)",
      border: `2px solid #4EC1EA`,
    },
    "& .cost-selected": {
      backgroundColor: "rgba(0, 128, 128, 0.03)",
      border: `2px solid #008080`,
    },
    "& .hotwater-selected": {
      backgroundColor: "rgba(225, 24, 24, 0.03)",
      border: `2px solid #E11818`,
    },
  };
};
